import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import StaticBlogs from "./Home"; // Your Blogs array
import HeaderOne from '../Components/Header/HeaderOne';
import Footer from '../Components/Footer/FooterOne';
import { Helmet } from "react-helmet-async";

const BlogList = () => {
  const itemsPerPage = 3; // Show 3 blogs per page
  const [currentPage, setCurrentPage] = useState(1);
  const [dbBlogs, setDbBlogs] = useState([]);

  useEffect(() => {
    const apiUrl = window.location.port === '3000' ? '/tt-react/public/blog-posts.php' : '/blog-posts.php';
    fetch(apiUrl)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setDbBlogs(data.data.map((b) => ({ id: b.slug, title: b.title, image: b.image })));
        }
      })
      .catch((err) => {
        console.error("FETCH ERROR IN BLOGS:", err);
      });
  }, []);

  const Blogs = [...dbBlogs, ...StaticBlogs];

  const totalPages = Math.ceil(Blogs.length / itemsPerPage);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentBlogs = Blogs.slice(startIndex, startIndex + itemsPerPage);

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  return (
    <>


      <Helmet>
                <title>Tickling Tummy Blog | Tips on Homemade Food & Healthy Eating in Coimbatore</title>
                <meta name="description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, located in R.S. Puram. We specialize in healthy daily meal subscriptions, customized pre-order tiffin services, and gourmet event catering." />
                <meta name="keywords" content="Tickling Tummy blog, homemade food tips, vegetarian cooking Coimbatore, healthy tiffin ideas, food blog Coimbatore" />
                <link rel="canonical" href="https://ticklingtummy.com/blogs" />
                
                {/* Open Graph Tags */}
                <meta property="og:title" content="Tickling Tummy Blog | Tips on Homemade Food & Healthy Eating in Coimbatore" />
                <meta property="og:description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, located in R.S. Puram. We specialize in healthy daily meal subscriptions, customized pre-order tiffin services, and gourmet event catering." />
                <meta property="og:image" content="https://ticklingtummy.com/assets/images/tickling-tummy-logo-coimbatore.svg" />
                <meta property="og:url" content="https://ticklingtummy.com/blogs" />
                <meta property="og:type" content="website" />
                
                {/* Twitter Card Tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Tickling Tummy Blog | Tips on Homemade Food & Healthy Eating in Coimbatore" />
                <meta name="twitter:description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, located in R.S. Puram. We specialize in healthy daily meal subscriptions, customized pre-order tiffin services, and gourmet event catering." />
                <meta name="twitter:image" content="https://ticklingtummy.com/assets/images/tickling-tummy-logo-coimbatore.svg" />
            </Helmet>
      <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://ticklingtummy.com"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Blog",
            "item": "https://ticklingtummy.com/blogs"
          }
        ]
      }, null, 2)}
      </script>
      <HeaderOne />

      {/* Inner Banner Section */}
      <section className="inner-banner">
        <div
          className="image-layer"
          style={{ backgroundImage: "url(assets/images/coimbatore-homemade-food-banner.jpg)" }}
        ></div>
        <div className="auto-container">
          <div className="inner">
            <h1>Blogs</h1>
            <div className="sub_text">
              <p>
                Home - <Link to="/" className="primary-color">Blogs</Link>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Blog List Section */}
      <section className="blog_list_section section-kt">
        <div className="auto-container">
          <div className="row">
            {/* Left Side */}
            <div className="col-lg-8">
              <div className="blog_left_side">
                {currentBlogs.map((blog) => (
                  <div key={blog.id} className="blog_panel">
                    <div className="main_img">
                      <Link to={`/${blog.id}`}>
                        <img src={blog.image ? (blog.image.startsWith('http') || blog.image.startsWith('/') ? blog.image : `/${blog.image}`) : `/assets/images/${blog.id}.webp`} alt={blog.title} />
                      </Link>
                    </div>
                    <div className="blog_info">
                      <ul>
                        <li> By: Ankita </li>
                        <li> <a href="https://ticklingtummy.com/"> Tickling Tummy </a> </li>
                      </ul>
                      <h4>
                        <Link to={`/${blog.id}`}>{blog.title}</Link>
                      </h4>
                      <div className="link-box">
                        <Link to={`/${blog.id}`} className="theme-btn btn-style-two clearfix">
                          <span className="btn-wrap">
                            <span className="text-one">read more</span>
                            <span className="text-two">read more</span>
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}

                {/* Pagination */}
                <div className="pagination mt-4 text-center">
                  <button
                    onClick={() => goToPage(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="page-btn"
                  >
                    Prev
                  </button>

                  {[...Array(totalPages)].map((_, index) => (
                    <button
                      key={index + 1}
                      onClick={() => goToPage(index + 1)}
                      className={`page-btn ${currentPage === index + 1 ? 'active' : ''}`}
                    >
                      {index + 1}
                    </button>
                  ))}

                  <button
                    onClick={() => goToPage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="page-btn"
                  >
                    Next
                  </button>
                </div>

              </div>
            </div>

            {/* Right Side */}
            <div className="col-lg-4">
              <div className="blog_right_side">
                <div className="categories_block bg_box">
                  <h6>Our Pages</h6>
                  <ul>
                    <li><Link to="/" className="cat"> Tickling Tummy</Link></li>
                    <li><Link to="/about" className="cat"> About </Link></li>
                    <li><Link to="/daily-meals" className="cat"> Daily Meals</Link></li>
                    <li><Link to="/catering" className="cat"> Catering</Link></li>
                    <li><Link to="/corporate" className="cat"> Corporate</Link></li>
                    <li><Link to="/food-delivery-in-train" className="cat"> Food Delivery in Train</Link></li>
                    <li><Link to="/meal-subscription" className="cat"> Meal Subscription</Link></li>
                    <li><Link to="/pre-order-meals" className="cat"> Pre Order Meals</Link></li>
                    <li><Link to="/gifting" className="cat"> Gifting</Link></li>
                    <li><Link to="/contact" className="cat"> Contact</Link></li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default BlogList;
